<fui-rows *ngIf="menu && formGroup" [formGroup]="formGroup" [hidden]="item">
    <fui-row label="wbo.screen-layout.edit.field-set.menu-properties">
        <fui-rows>
            <fui-row>
                <fui-column>
                    <wbo-textarea-edit-control [(ngModel)]="displayName"
                                               formControlName="displayName">
                    </wbo-textarea-edit-control>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-course-single-select-edit-control [(ngModel)]="courseId"
                                                           formControlName="courseId"
                                                           [readonly]="!courseDefinitionId"
                                                           [courseDefinitionId]="courseDefinitionId">
                    </wbo-course-single-select-edit-control>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-color-edit-control [(ngModel)]="colour"
                                                formControlName="colour">
                        </wbo-color-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-color-edit-control [(ngModel)]="foreColour"
                                                formControlName="foreColour">
                        </wbo-color-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-three-columns>
                    <fui-column>
                        <wbo-font-single-select-edit-control [(ngModel)]="menu.fontName"
                                                             formControlName="fontName">
                        </wbo-font-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-font-style-single-select-edit-control [(ngModel)]="menu.fontStyle"
                                                                   formControlName="fontStyle">
                        </wbo-font-style-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-font-size-single-select-edit-control [(ngModel)]="menu.fontSize"
                                                                  formControlName="fontSize">
                        </wbo-font-size-single-select-edit-control>
                    </fui-column>
                </fui-three-columns>
            </fui-row>
        </fui-rows>
    </fui-row>
    <fui-row *ngIf="!(editService.$entityRestricted | async)">
        <div class="toolBar">
            <fui-pop-button (click)="model.removeMenu(menu)" *ngIf="(model.menus$ | async).length > 1"
                            [title]="'wbo.screen-layout.edit.action.touchItem.remove'"></fui-pop-button>
        </div>
    </fui-row>
</fui-rows>
